var _mask, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 319,
    height: 319,
    viewBox: "0 0 319 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 319,
    height: 319
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 159.5,
    cy: 159.5,
    r: 159.5,
    fill: "url(#paint0_linear)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.35,
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47.001,
    y: 69.0669,
    width: 224.338,
    height: 251.924,
    rx: 1.93237,
    transform: "rotate(-0.0805182 47.001 69.0669)",
    fill: "black"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 47.001,
    y: 69.0669,
    width: 224.338,
    height: 251.924,
    rx: 1.93237,
    transform: "rotate(-0.0805182 47.001 69.0669)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0044 71.1016C47.0029 70.0343 47.8669 69.168 48.9341 69.1665L269.407 68.8566C270.474 68.8551 271.341 69.7191 271.342 70.7863L271.358 81.8371L47.02 82.1524L47.0044 71.1016Z",
    fill: "#646B7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5934 79.494C61.3858 79.4915 62.8367 78.0365 62.8342 76.2441C62.8317 74.4517 61.3766 73.0007 59.5843 73.0033C57.7919 73.0058 56.3409 74.4608 56.3434 76.2532C56.3459 78.0456 57.801 79.4966 59.5934 79.494Z",
    fill: "#4E5465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5465 79.494C72.3389 79.4915 73.7899 78.0365 73.7873 76.2441C73.7848 74.4517 72.3298 73.0007 70.5374 73.0033C68.745 73.0058 67.294 74.4608 67.2966 76.2532C67.2991 78.0456 68.7541 79.4966 70.5465 79.494Z",
    fill: "#AAAFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0941 79.494C82.8865 79.4915 84.3375 78.0365 84.3349 76.2441C84.3324 74.4517 82.8774 73.0007 81.085 73.0033C79.2926 73.0058 77.8416 74.4608 77.8442 76.2532C77.8467 78.0456 79.3017 79.4966 81.0941 79.494Z",
    fill: "#AAAFBF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.9998,
    y: 100,
    width: 166.214,
    height: 80.6063,
    rx: 1.28824,
    transform: "rotate(-0.0805182 74.9998 100)",
    fill: "#F4F5F8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.291 240.215C134.29 239.503 134.866 238.926 135.578 238.925L182.114 238.859C182.825 238.858 183.403 239.434 183.404 240.146L183.469 286.681C183.47 287.393 182.894 287.971 182.183 287.972L135.647 288.037C134.935 288.038 134.358 287.462 134.357 286.75L134.291 240.215ZM76.8553 240.297C76.8543 239.585 77.4303 239.008 78.1418 239.007L124.678 238.942C125.389 238.941 125.967 239.516 125.968 240.228L126.033 286.764C126.034 287.475 125.458 288.053 124.747 288.054L78.2108 288.119C77.4993 288.12 76.9217 287.544 76.9207 286.833L76.8553 240.297ZM193.431 238.844C192.719 238.845 192.143 239.423 192.144 240.134L192.21 286.67C192.211 287.382 192.788 287.958 193.5 287.957L240.036 287.891C240.747 287.89 241.323 287.313 241.322 286.601L241.257 240.065C241.256 239.354 240.678 238.778 239.967 238.779L193.431 238.844Z",
    fill: "#E1E5F0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.3994,
    y: 185.774,
    width: 101.972,
    height: 8.16266,
    rx: 3.24013,
    transform: "rotate(-0.0805182 75.3994 185.774)",
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.418,
    y: 199.038,
    width: 91.7746,
    height: 8.16266,
    rx: 3.24013,
    transform: "rotate(-0.0805182 75.418 199.038)",
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.4375,
    y: 212.304,
    width: 81.5774,
    height: 8.16266,
    rx: 3.24013,
    transform: "rotate(-0.0805182 75.4375 212.304)",
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.625,
    y: 185.614,
    width: 50.9859,
    height: 16.3253,
    rx: 1,
    transform: "rotate(-0.0805182 190.625 185.614)",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.363,
    y: 292.201,
    width: 42.4531,
    height: 6.65931,
    rx: 2.57649,
    transform: "rotate(-0.0805182 134.363 292.201)",
    fill: "#C8C9CD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.381,
    y: 303.44,
    width: 25.3886,
    height: 6.65931,
    rx: 2.57649,
    transform: "rotate(-0.0805182 134.381 303.44)",
    fill: "#C8C9CD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.9282,
    y: 292.282,
    width: 42.4531,
    height: 6.65931,
    rx: 2.57649,
    transform: "rotate(-0.0805182 76.9282 292.282)",
    fill: "#C8C9CD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.9434,
    y: 303.521,
    width: 25.3886,
    height: 6.65931,
    rx: 2.57649,
    transform: "rotate(-0.0805182 76.9434 303.521)",
    fill: "#C8C9CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.794 292.117C193.371 292.119 192.219 293.275 192.221 294.698L192.223 296.204C192.225 297.627 193.38 298.779 194.803 298.777L231.687 298.725C233.11 298.723 234.262 297.568 234.26 296.145L234.258 294.639C234.256 293.216 233.101 292.064 231.678 292.066L194.794 292.117ZM194.808 303.355C193.385 303.357 192.233 304.512 192.235 305.935L192.238 307.441C192.24 308.864 193.395 310.016 194.818 310.014L215.053 309.985C216.476 309.983 217.628 308.828 217.626 307.405L217.624 305.899C217.622 304.476 216.467 303.324 215.044 303.326L194.808 303.355Z",
    fill: "#C8C9CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.577 129.97L180.577 157.912L134.01 157.912L134.01 129.97L157.294 116L180.577 129.97Z",
    fill: "#4165FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.577 129.97L180.577 157.912L157.294 157.912L157.294 116L180.577 129.97Z",
    fill: "#234CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 129.971L134.009 116L157.293 116L151.284 129.971L128 129.971Z",
    fill: "#6380FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.587 129.971L180.578 116L157.293 116L163.303 129.971L186.587 129.971Z",
    fill: "#2F56FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.494 146.203L145.253 146.203L145.253 149.962L141.494 149.962L141.494 146.203Z",
    fill: "#5273FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189 153.501C189 159.851 183.851 165 177.5 165C171.148 165 166 159.851 166 153.501C166 147.149 171.148 142 177.5 142C183.851 142 189 147.149 189 153.501Z",
    fill: "#1EB27A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -96.999,
    y: -71.2483,
    width: 512.692,
    height: 540.239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 72
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 159.5,
    y1: 0,
    x2: 159.5,
    y2: 319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7EEFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE4F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProduct);
export default __webpack_public_path__ + "static/media/empty-product.ca5f2a23.svg";
export { ForwardRef as ReactComponent };